import { observer } from 'mobx-react-lite';
import { CSVLink } from 'react-csv';
import { Dropdown, Form, Icon, Input} from 'semantic-ui-react';
import {
  TemplateSubTasks,
  TemplateTask,
  WorkflowElement,
} from '../../../app/models/template';
import { store, useStore } from '../../../app/stores/store';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Papa from 'papaparse';
import { Options } from '../../../app/models/TitleCreate';

interface Props {
  FileCallBackFunc: any;
  activity: any;
  elementTypeID: string;
  setCsvUploaded: any;
  selectedReelName:string
  setSelectedReelName:Dispatch<SetStateAction<string>>
}

function MultipleCSV({
  FileCallBackFunc,
  activity,
  elementTypeID,
  setCsvUploaded,
  selectedReelName,
  setSelectedReelName
}: Props) {
  const { metaDataStore, WorkLevelStore, dashboardStore,userStore:{user},viewStore,RestorationStore,commonStore } = useStore();
  const { WorkflowMetadataHandler } = metaDataStore;
  const [metadataList, setMetadataList] = useState<any[]>([]);
  const[restorationReelOption,setRestorationReelOption]=useState<Options[]>([]);
  useEffect(() => {
    if (elementTypeID) {
      WorkflowMetadataHandler(elementTypeID).then((Response) => {
        setMetadataList(Response || []);
      });
      WorkLevelStore.loadWorkLevelBasedOnItemLevel(activity.id);
    }
    
    reelLoad(activity.id);
    // eslint-disable-next-line
  }, [activity, elementTypeID]);

  const csvData: any[] = [[]]; //first array for header ,second for value

  for (let key in activity) {
    // display the properties
    if (key === 'title') {
      csvData[0].push(key); // for header
    }
  }
  metadataList?.forEach((metadata) => {
    if (metadata.isActive !== false) {
      if (
        metadata.elementType !== 'Barcode' &&
        metadata.elementType !== 'AddPhotograph' &&
        metadata.elementType !== 'Dynamicmetadata' &&
        metadata.elementType !== 'AddFiles'
      ) {
        csvData[0].push(`Metadata~${metadata.elementName}`); // for header
      }
    }
  });

  //find the length of subtask and elements;
  const WorkFlowHeaders = dashboardStore.dashboard.CreateOrderTemplate?.tasks;
  //to handle workflow data
  WorkFlowHeaders?.forEach((task: TemplateTask) => {
    if (task.isActive !== false) {
      task?.subTasks?.forEach((subtask: TemplateSubTasks) => {
        if (subtask.isActive !== false) {
          // csvData[0].push("."+task.taskName+"."+subtask.subTaskName);//for value
          subtask?.elements?.forEach((elem: WorkflowElement) => {
            if (elem.isActive !== false) {
              if (
                elem.elementType !== 'Barcode' &&
                elem.elementType !== 'AddPhotograph' &&
                elem.elementType !== 'Dynamicmetadata' &&
                elem.elementType !== 'AddFiles'
              ) {
                csvData[0].push(
                  '.' +
                    task.taskName +
                    '.' +
                    subtask.subTaskName +
                    '.' +
                    elem.elementName,
                ); //for value
              }
            }
          });
        }
      });
    }
    // csvData[0].push("."+task.taskName);//for header
  });


  if(user?.customerName === 'Restoration'){
    const arrangeBasedOnOrder =(orderArray:any[], targetArray:any[])=> {
      return orderArray.reduce((arrangedArray, item) => {
        if (targetArray.includes(item)) {
          arrangedArray.push(item);
        }
        return arrangedArray;
      }, []);
    }
    
    
    
    //   [
      //     "title",
      //     "Metadata~Title_Code",
      //     "Metadata~Shot_Estimate_Time",
      //     "Metadata~Estimation Min Per Frame",
  //     "Metadata~Output Path",
  //     "Metadata~Reel_Name",
  //     "Metadata~Displayname",
  //     "Metadata~Input Path",
  //     "Metadata~Team",
  //     "Metadata~Start_Frame",
  //     "Metadata~Reject History",
  //     "Metadata~Total_Frame",
  //     "Metadata~Resolution",
  //     "Metadata~Complexity_Level",
  //     "Metadata~PL_Name",
  //     "Metadata~Shot_Name",
  //     "Metadata~End_Frame"
  // ]
  const metadata = [
    'Metadata~Displayname',
   // 'Metadata~Reel_Name',
    'Metadata~Start_Frame',
    'Metadata~End_Frame',
    'Metadata~Total_Frame',
    'Metadata~PL_Name',
    'Metadata~Shot_Name',
    'Metadata~Input Path',
    'Metadata~Output Path',
    'Metadata~Complexity_Level',
    'Metadata~Estimation Min Per Frame',
    'Metadata~Shot_Estimate_Time',
  ];
  csvData[0] = csvData[0].filter((value:string) => metadata.includes(value));
  csvData[0] = arrangeBasedOnOrder(metadata, csvData[0]);
}

const enableCSVButton = () => {
  if (elementTypeID !== '') {
    return { 'pointer-events': 'auto', opacity: 1 };
  } 
  return { 'pointer-events': 'none', opacity: 0.5 };
};

const reelLoad=async (id:string)=>{
  await RestorationStore.TitleReelNameListOption(id);
  setRestorationReelOption(RestorationStore.TitleInventoryNameList);
}

return (
    <div>
      <div>
        { commonStore.RestorationCustomer && (
        <div>
          <Form.Field>
              <label><b>Reel Name:</b></label> 
              <Dropdown 
                clearable
                fluid
                search
                required
                selection
                options={restorationReelOption}
                onChange={(e,{value})=>setSelectedReelName(value as string)}
                name="Reel"
              />
            </Form.Field>
            <br/>
          </div>)}
      </div>
      <div style={enableCSVButton()}>
        
        <Input
          className={commonStore.RestorationCustomer && !selectedReelName ? 'component-isDisabled' : ''}
          disabled={elementTypeID === '' ? true : false}
          type="file"
          accept=".csv,.xlsx,.xls"
          onChange={(e) => {
            const files = e.target.files;
            if (files) {
              setCsvUploaded(true);
              Papa.parse(files[0], {
                complete: function (results:any) {
                  if (user?.customerName === 'Restoration') {
                    let titleIndex = -1;
                    let titleCodeIndex = -1;
                    let teamIndex = -1;
                    let reelIndex = -1;
                    
                    if (!results.data[0].includes('title')) {
                        results.data[0] = results.data[0]?.filter((item: any) => item !== 'title');
                        results.data[0].push('title');
                        titleIndex = results.data[0].indexOf('title');
                    } else {
                        titleIndex = results.data[0].indexOf('title');
                    }
                    
                    if (!results.data[0].includes('Metadata~Title_Code')) {
                        results.data[0] = results.data[0]?.filter((item: any) => item !== 'Metadata~Title_Code');
                        results.data[0].push('Metadata~Title_Code');
                        titleCodeIndex = results.data[0].indexOf('Metadata~Title_Code');
                    } else {
                      titleCodeIndex = results.data[0].indexOf('Metadata~Title_Code');
                    }
                    
                    if (!results.data[0].includes('Team')) {
                        results.data[0] = results.data[0]?.filter((item: any) => item !== 'Team');
                        results.data[0].push('Team');
                        teamIndex = results.data[0].indexOf('Team');
                    }
                    else{
                      teamIndex = results.data[0].indexOf('Team');
                    }

                    if (!results.data[0].includes('Metadata~Reel_Name')) {
                      results.data[0] = results.data[0]?.filter((item: any) => item !== 'Metadata~Reel_Name');
                      results.data[0].push('Metadata~Reel_Name');
                      reelIndex = results.data[0].indexOf('Metadata~Reel_Name');
                  }
                  else{
                    reelIndex = results.data[0].indexOf('Metadata~Reel_Name');
                  }
                    
                     
                    const titleValue = viewStore.metadata.find(element => element.elementName === 'Title Code')?.elementValue || ''; //activity.title.split('- Restoration - TitleProcess')[0].trim() || '';
                    const titleCodeValue = titleValue; //viewStore.metadata.find(element => element.elementName === 'Title Code')?.elementValue || '';
                    const teamValue = viewStore.metadata.find(element => element.elementName === 'Team')?.elementValue || '';
                    const reelValue=selectedReelName;
                
                    for (let i = 1; i < results.data.length - 1; i++) {
                        results.data[i][titleCodeIndex] = titleCodeValue;
                        results.data[i][teamIndex] = teamValue;
                        results.data[i][titleIndex] = titleValue;
                        results.data[i][reelIndex] = reelValue;
                    }
                }
                if(store.userStore.user?.customerName === 'PCPLCRM' && store.userStore.user?.roleName === 'IT Team'){
                  // eslint-disable-next-line no-control-regex
                  results.data = results.data.map((row:any) => row.map((cell:any) => cell.replace(/[^\x00-\x7F]/g, '-')));
                }
                FileCallBackFunc(results.data, metadataList)
                },
              });
            }
          }}
        />
        <CSVLink data={csvData} filename='Sections_Multiple_Bulk_Upload-csv'>
          <Icon
            style={{ marginTop: '5px', marginLeft: '400px' }}
            corner="bottom right"
            size="large"
            circular
            inverted
            color="teal"
            name="file excel outline"
          />
        </CSVLink>
      </div>
    </div>
  );
}

export default observer(MultipleCSV);
